//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import logo_college_white from '~/assets/images/logo/logo_college_white.png'
export default {
    data() {
        return {
            logo: logo_college_white
        }
    }
}
